import { css } from 'styled-components'

export default css`
  justify-content: flex-end;
  overflow: visible;
`
